export const splitLink = (link: string) => {
	// Split into array seperated by "/; removing empty items.
	return link.split("/").filter((n) => n);
};
